import React from 'react'
import { Spacer, Text, View } from 'oio-react'
import { BoltIcon, PageGlyphIcon24, SiteNavigationIcon } from 'assets/icons'
import contentTypeThemes from 'config/constants/contentTypeThemes'
import { settingsUrl, settingsContentUrl } from 'config/constants/urls'
import ProtoColumnNavButton from 'src/components/Settings/ProtoColumnNavButton'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import { useOrganization } from 'src/graphql/hooks'

const SettingsContentHome = () => {
   const { organization } = useOrganization()
   const enabledInitiativeTypes = organization.initiativeTypes.filter(t => t.enabled)

   return (
      <>
         <View
            position="absolute"
            top="0px"
            left="0px"
            right="0px"
            bottom="0px"
            scroll="on">
            <ProtoReturnBar
               display="block[a-b] none[c-f]"
               returnLinkName="Admin Workspace"
               returnLinkTo={settingsUrl}
            />
            <View
               display="flex"
               justifyContent="center"
               width="100%">
               <View width="100%" maxWidth="90%[c] 480px[d]">
                  <View
                     float="left"
                     display="flex"
                     padding="40px 20px[a-b] 40px 0px[c-d] 40px 20px[e-f]">
                     <ProtoHeadingBlock
                        colorMode="light"
                        title="Content & Pages"
                        description="Create and organize all your Community's site content and content types. Manage the publishing status of all your content."
                        metatext={`You have ${enabledInitiativeTypes.length + 1} active content types`}
                     />
                  </View>
                  <View float="left" width="100%" paddingBottom="90px">
                     <View
                        backgroundColor="#fafafa"
                        padding="10px 0px[c-d]"
                        borderRadius="6px[c-d]"
                        borderTop="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]"
                        borderBottom="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]">
                        <ProtoColumnNavButton
                           borderStyle="none"
                           linkName="Main Menu"
                           linkTo={`${settingsContentUrl}/main-menu`}
                           icon={(
                              <SiteNavigationIcon
                                 className="icon"
                                 width="15px"
                                 height="15px"
                              />
                           )}
                        />
                     </View>
                     <View width="100%" padding="15px 20px[a-b] 15px 0px[c-d] 15px 20px[e-f]">
                        <Spacer size="6" />
                        <Text size="1.5" weight="medium" color="#000">
                           All Site Content
                        </Text>
                     </View>
                     <View
                        backgroundColor="#fafafa"
                        padding="10px 0px[c-d]"
                        borderRadius="6px[c-d]"
                        borderTop="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]"
                        borderBottom="1px solid rgba(0,0,0,0.05)[a-b] 1px solid rgba(0,0,0,0.05)[e-f]">
                        <ProtoColumnNavButton
                           borderStyle="none"
                           linkName="Custom Pages"
                           linkTo={`${settingsContentUrl}/pages`}
                           icon={<PageGlyphIcon24 className="icon" width="14px" height="14px" />}
                        />
                        {enabledInitiativeTypes.map((type, index) => {
                           const typeClass = type.class || 'resource'
                           const Icon = contentTypeThemes[typeClass]?.icon

                           return (
                              <ProtoColumnNavButton
                                 key={type.id}
                                 linkName={type.namePlural}
                                 linkTo={`${settingsContentUrl}/initiativeType/${type.id}`}
                                 icon={Icon && (
                                    <Icon
                                       className="icon"
                                       width="14px"
                                       height="14px"
                                    />
                                 )}
                              />
                           )
                        })}
                        <ProtoColumnNavButton
                           borderStyle="none"
                           linkName="Manage Content Types"
                           linkTo={`${settingsContentUrl}/manage-content-types`}
                           icon={<BoltIcon className="icon" width="14px" height="14px" />}
                        />
                     </View>
                  </View>
               </View>
            </View>
         </View>
      </>
   )
}

export default SettingsContentHome
